import HealthcareSiteInventoryContainer from './healthcare-site-inventory-container';

export default HealthcareSiteInventoryContainer;
